import { useForm as createUseForm } from '@ant-design-vue/use';
import { Col, Row } from 'ant-design-vue';
import lodash from 'lodash';
import moment from 'moment';
import { defineAsyncComponent, reactive, toRaw } from 'vue';
import { addModal, setIsLoading as setIsLoadingApp } from '../../../../app.logic';
import { openModalForm as openModalFormRemark } from '../../../../components/form/remark-form.logic';
import { setAppPageHeader } from '../../../../components/layout/app-layout/app-layout.logic';
import i18n from '../../../../i18n';
import store from '../../../../store';
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from '../../../../utils/button';
import { modalStyleIFrame } from '../../../../utils/constant';
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView
} from '../../../../utils/form';
import { createLoading } from '../../../../utils/loading';
import { has } from '../../../../utils/menu-context';
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from '../../../../utils/page';
import { flatWhereGroup } from '../../../../utils/search';
import { addRules, required, validateError } from '../../../../utils/validate';
import { createConditionAction, createConditionForm } from './company-doc-reject.condition';
import {
    callCompanyById,
    callCompanyDocRejectStatus,
    callCompanyDocRejectType,
    callSamplingProductById,
    createColumnsForCompanyDocReject,
    createColumnsForFollowUp,
    createColumnsForInvestigation,
    createField,
    onChangeSamplingProduct
} from './company-doc-reject.section';

const CIFrame = defineAsyncComponent(() => import('../../../../components/iframe/CIFrame'));
const CIcon = defineAsyncComponent(() => import('../../../../components/icon/CIcon'));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = 'resource/v1/transaction/companyDocReject';

export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, {
    id,
    config: { params: { isHardDelete: true } }
});
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, {
    ids,
    config: { params: { isHardDelete: true } }
});
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callReportInvestigationForm = ({ data }) => store.dispatch(`${actionPrefix}/reportInvestigationForm`, { data });
export const callReportFollowupRejectForm = ({ data }) => store.dispatch(`${actionPrefix}/reportFollowupRejectForm`, { data });

export const callCompanyDocRejectProject = () => store.dispatch(`resource/v1/transaction/companyDocRejectProduct/search`, {
        criteria: {
            select: ['*', 'refSamplingProduct.id'],
            page: 0,
            size: 1000000,
            where: [],
            children: []
        }
    }
);

export const onSearch = ({ props, page, isSet = true }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({
        criteria: {
            ...page,
            data: [],
            where: [...where, ...createWhereRole({ props })],
            sort: [...sort, { name: 'updateDate', type: 'DESC' }]
        }
    })
        .then(page => (isSet ? (state.page = { ...page, where, sort }) : page))
        .finally(() => setIsLoading(false));
};

export const onClickSave = ({ props, data, refs, refStatus }) => {
    const { viewOnly, routerPrefix } = props;
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callSave({ form: refStatus ? { ...data.useForm.modelRef, refStatus } : data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
                .then(record => {
                    if (viewOnly) initForm({ props, data, refs });
                    else onClickView({ record, routerPrefix });
                });
        })
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const onClickReport = ({ callReport, fileName, type = 'application/pdf' }) => {
    setIsLoadingApp(true);
    return callReport()
        .then(byte => {
            const { saveAs } = require('file-saver');
            const blob = new Blob([byte], { type });
            saveAs(blob, fileName);
        })
        .finally(() => setIsLoadingApp(false));
};

export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ['**', 'refCompany.**', 'refCompanyCert.refExportCountry.*'],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: [
                {
                    name: 'refCompany.userCompanies',
                    select: ['id'],
                    page: 0,
                    size: 1,
                    sort: [{ name: 'createDate', type: 'ASC' }]
                },
                { name: 'attachments', select: ['*'], page: 0, size: 1000000, sort: [] },
                {
                    name: 'companyDocRejectProducts',
                    select: [
                        '*',
                        'refSamplingProduct.*',
                        'refCompanyProduct.**',
                        //"refSamplingProduct.refCountry1.*",
                        //"refSamplingProduct.refCountry2.*",
                        'refSamplingProduct.refSamplingRequest.*',
                        'refSamplingProduct.refSamplingRequest.refSamplingDepartment.*'
                    ],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: 'createDate', type: 'ASC' }],
                    children: [
                        {
                            name: 'analysiss',
                            select: ['*', 'refLabType.*', 'refLabResultStatus.*'],
                            page: 0,
                            size: 1000000,
                            sort: [],
                            children: [
                                {
                                    name: 'topics',
                                    select: ['refLabTopic.*', 'refLabTopic.refLabTopicUnit.*'],
                                    page: 0,
                                    size: 1000000,
                                    sort: []
                                }
                            ]
                        },
                        {
                            name: 'refSamplingProduct.analysiss',
                            select: ['*', 'refLabType.*', 'refLabResultStatus.*'],
                            page: 0,
                            size: 1000000,
                            where: [
                                { name: 'refTransferFrom.id', type: 'UUID', operator: '=', value: null },
                                { name: 'refLabResultStatus.key', type: 'String', operator: '=', value: 'Reject' }
                            ],
                            sort: []
                        },
                        {
                            name: 'topics',
                            select: ['*', 'refTopic.*', 'refTopic.refLabType.*'],
                            page: 0,
                            size: 1000000,
                            sort: [],
                            children: []
                        },
                        {
                            name: 'samplingProducts',
                            select: ['*', 'refSamplingRequest.*', 'refStatus.*', 'refAcceptanceStatus.*', 'refCompanyProduct.refProduct.*'],
                            page: 0,
                            size: 1000000,
                            sort: [],
                            where: [{
                                name: 'refStatus.key',
                                type: 'String',
                                operator: 'in',
                                value: ['Send Lab', 'Send Result']
                            }],
                            children: [
                                {
                                    name: 'analysiss',
                                    select: ['*', 'refLabType.*', 'refLabResultStatus.*'],
                                    page: 0,
                                    size: 1000000,
                                    sort: [],
                                    children: [
                                        {
                                            name: 'topics',
                                            select: ['refLabTopic.*', 'refLabTopic.refLabTopicUnit.*'],
                                            page: 0,
                                            size: 1000000,
                                            sort: []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
                /*
                {
                    name: "samplingRequests",
                    select: ["*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }],
                    children: [
                        {
                            name: "samplingProducts",
                            select: ["*", "refSamplingRequest.*", "refStatus.*", "refAcceptanceStatus.*", "refCompanyProduct.refProduct.*"],
                            page: 0,
                            size: 1000000,
                            sort: [{ name: "createDate", type: "ASC" }],
                            children: [
                                {
                                    name: "analysiss",
                                    select: ["*", "refLabType.*", "refLabResultStatus.*"],
                                    page: 0,
                                    size: 1000000,
                                    sort: [],
                                    children: [
                                        {
                                            name: "topics",
                                            select: ["refLabTopic.*", "refLabTopic.refLabTopicUnit.*"],
                                            page: 0,
                                            size: 1000000,
                                            sort: []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
                */
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: [
                {
                    name: 'companyDocRejectProducts',
                    select: ['refSamplingProduct.samplingNo', 'refSamplingProduct.refSamplingRequest.refSamplingDepartment.nameTh'],
                    page: 0,
                    size: 1000000
                }
            ]
        };
    }
};

export const createFormTitle = ({ data }) => {
    const { modelRef, initialModel } = data.useForm;
    return modelRef.id
        ? `
        ${modelRef.docNo ? `${modelRef.docNo} ` : ''}
        (${initialModel.refStatus?.value})
    `
        : i18n.global.t('button.create');
};

export const createWhereRole = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    if (has({ menuContext, key: 'forCompany' })) {
        whereGroup.push([
            {
                name: 'refCompany.userCompanies.refUser.username',
                type: 'String',
                operator: '=',
                value: userInfo.username
            },
            { name: 'refStatus.key', type: 'String', operator: '!=', value: 'Draft' }
        ]);
    }
    if (has({ menuContext, key: 'forCompanyOfficer' })) {
        let companyDocRejectTypeKey = null;
        if (routerPrefix.includes('investigation')) {
            companyDocRejectTypeKey = '1';
        } else if (routerPrefix.includes('follow-up')) {
            companyDocRejectTypeKey = '2';
        }
        whereGroup.push([{
            name: 'refCompanyDocRejectType.key',
            type: 'String',
            operator: '=',
            value: companyDocRejectTypeKey
        }]);
    }
    return flatWhereGroup({ where: whereGroup, logic: 'OR' });
};

export const createForm = () => {
    return {
        refCompany: null,
        docNo: null,
        receiveDatetime: null,
        refCompanyDocRejectType: null,
        dueDatetime: null,
        refStatus: null,
        desc: null,
        refCompanyCert: null,
        refCountry: null,
        isSuspended: null,
        destinationCountryDatetime: null,
        refCode: null,
        refCompanyDocRejectReview: null,
        reviewDatetime: null,
        reviewRemark: null,
        remark: null,
        reviewSpecialDueDatetime: null,
        reviewSpecialCanceledDatetime: null,
        reviewSpecialRemark: null,
        reviewSpecialCanceledRemark: null,
        isReviewSpecialMicro: null,
        isReviewSpecialChemi: null,
        isReviewSpecialPhysic: null,
        refSamplingRequest: null,
        refAttach: null,
        problem: null,
        planDatetime: null,
        planRemark: null,
        attachments: [],
        companyDocRejectProducts: []
    };
};

export const createRules = () => {
    return {
        receiveDatetime: [required],
        refCompany: [required],
        dueDatetime: [required]
    };
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form, routerPrefix } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initByRole({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ data }) => {
    const promises = [];
    promises.push(
        Promise.all([callCompanyDocRejectStatus({}), callCompanyDocRejectType({}), callCompanyDocRejectProject()]).then(arr => {
            data.statuses = arr[0];
            data.docRejectTypes = arr[1];
            data.allCompanyDocRejectProducts = arr[2]?.data?.filter(it => it.refSamplingProduct).map(d => d?.refSamplingProduct?.id);
        })
    );
    return Promise.all(promises);
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    if (routerPrefix.includes('investigation')) {
        state.investigationColumns = createColumnsForInvestigation({ props }).map(d => {
            return lodash.mergeWith(
                state.investigationColumns.find(d2 => d.dataIndex === d2.dataIndex),
                d,
                (objValue, srcValue, key) => {
                    if (['searchValue'].includes(key)) return objValue;
                }
            );
        });
        state.columns = state.investigationColumns;
    } else if (routerPrefix.includes('follow-up')) {
        state.followUpColumns = createColumnsForFollowUp({ props }).map(d => {
            return lodash.mergeWith(
                state.followUpColumns.find(d2 => d.dataIndex === d2.dataIndex),
                d,
                (objValue, srcValue, key) => {
                    if (['searchValue'].includes(key)) return objValue;
                }
            );
        });
        state.columns = state.followUpColumns;
    } else if (routerPrefix.includes('company-doc-reject')) {
        state.companyDocRejectColumns = createColumnsForCompanyDocReject({ props }).map(d => {
            return lodash.mergeWith(
                state.companyDocRejectColumns.find(d2 => d.dataIndex === d2.dataIndex),
                d,
                (objValue, srcValue, key) => {
                    if (['searchValue'].includes(key)) return objValue;
                }
            );
        });
        state.columns = state.companyDocRejectColumns;
    }
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({
                    rowSelection,
                    callActiveAll,
                    state,
                    onSearch: search => onSearch({ props, ...search }),
                    setIsLoading
                })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({
                    rowSelection,
                    callArchiveAll,
                    state,
                    onSearch: search => onSearch({ props, ...search }),
                    setIsLoading
                })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({
                    rowSelection,
                    callDeleteAll,
                    state,
                    onSearch: search => onSearch({ props, ...search }),
                    setIsLoading
                }),
            getCheckboxProps: ({ record }) => ({ disabled: !['Draft'].includes(record?.refStatus?.key) })
        }),
        createManageExportCsv({
            menuContext,
            callData: ({ page }) => onSearch({
                props,
                page: { ...lodash.cloneDeep({ ...page, page: 0, size: 1000000 }) },
                isSet: false
            })
        })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        })
    ];
};

export const initForm = ({ props, data, refs }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs, isLoading });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({
                        props,
                        data,
                        refs,
                        state,
                        routerPrefix,
                        onClickView,
                        onClickEdit
                    }),
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
};

export const initByRole = ({ props, data, key }) => {
    const { menuContext, routerPrefix, viewOnly } = props;
    const { id, useForm } = data;
    const { modelRef, initialModel } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const initModel = key ? lodash.get(initialModel, key) : initialModel;
    const prefix = key ? `${key}.` : '';
    if (routerPrefix.includes('investigation')) {
        model.refCompanyDocRejectType = data.docRejectTypes.find(d => d.key === '1');
        if (has({ menuContext, key: 'forCompanyOfficer' })) {
            if ([undefined, 'Draft'].includes(initModel.refStatus?.key)) {
                addRules({ useForm, modelRef, key: `${prefix}destinationCountryDatetime`, rules: [required] });
            }
            if (['Plan'].includes(initModel.refStatus?.key)) {
                if (!viewOnly) {
                    if (!model.reviewDatetime) {
                        model.reviewDatetime = moment().format('YYYY-MM-DD[T]HH:mm:00Z');
                    }
                }
                addRules({ useForm, modelRef, key: `${prefix}refCompanyDocRejectReview`, rules: [required] });
                addRules({ useForm, modelRef, key: `${prefix}reviewDatetime`, rules: [required] });
            }
        }
    } else if (routerPrefix.includes('follow-up')) {
        model.refCompanyDocRejectType = data.docRejectTypes.find(d => d.key === '2');
        if (!id && data.samplingProductId) {
            callSamplingProductById({ id: data.samplingProductId }).then(samplingProduct => {
                let companyDocRejectProduct = model.companyDocRejectProducts.find(d => d.isDelete !== true);
                if (!companyDocRejectProduct) {
                    model.companyDocRejectProducts.unshift((companyDocRejectProduct = { analysiss: [], topics: [] }));
                }
                companyDocRejectProduct.isSave = true;
                onChangeSamplingProduct({ companyDocReject: model, samplingProduct });
                callCompanyById({ id: samplingProduct.refSamplingRequest.refCompany.id }).then(d => (model.refCompany = d[0]));
            });
        }
        if (has({ menuContext, key: 'forCompanyOfficer' })) {
            if (['Plan'].includes(initModel.refStatus?.key)) {
                if (!viewOnly) {
                    if (!model.reviewDatetime) {
                        model.reviewDatetime = moment().format('YYYY-MM-DD[T]HH:mm:00Z');
                    }
                    const companyDocRejectProduct = model.companyDocRejectProducts.find(d => d.isDelete !== true);
                    if (companyDocRejectProduct) {
                        companyDocRejectProduct.isSave = true;
                    }
                }
                addRules({ useForm, modelRef, key: `${prefix}refCompanyDocRejectReview`, rules: [required] });
                addRules({ useForm, modelRef, key: `${prefix}reviewDatetime`, rules: [required] });
            }
        }
    } else if (routerPrefix.includes('company-doc-reject')) {
        if (has({ menuContext, key: 'forCompany' })) {
            if (['Wait'].includes(initModel.refStatus?.key)) {
                if (!viewOnly && !model.planDatetime) {
                    model.planDatetime = moment().format('YYYY-MM-DD[T]HH:mm:00Z');
                }
                addRules({ useForm, modelRef, key: `${prefix}planDatetime`, rules: [required] });
            }
        }
    }
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canSendWait = state.conditionAction.canSendWait({ props, record: initialModel });
    const canSendPlan = state.conditionAction.canSendPlan({ props, record: initialModel });
    const canNoPlan = state.conditionAction.canNoPlan({ props, record: initialModel });
    const canDownloadInvestigationForm = state.conditionAction.canDownloadInvestigationForm({
        props,
        record: initialModel
    });
    const canDownloadRejectForm = state.conditionAction.canDownloadRejectForm({ props, record: initialModel });
    if (id && has({ menuContext, key: 'canCreate' })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: 'm-1' }));
    }
    if (!viewOnly && id && has({ menuContext, key: 'canView' })) {
        col1.push(createButtonView({
            onClick: () => onClickView({ record: { id }, routerPrefix }),
            classStyle: 'm-1'
        }));
    }
    if (viewOnly && id && isActive && has({ menuContext, key: 'canEdit' }) && canEdit) {
        col1.push(createButtonEdit({
            onClick: () => onClickEdit({ record: { id }, routerPrefix }),
            classStyle: 'm-1'
        }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        let options = null;
        if (
            ['Plan'].includes(initialModel.refStatus?.key) &&
            modelRef.refCompanyDocRejectReview?.key !== initialModel.refCompanyDocRejectReview?.key
        ) {
            options = {
                text: `${viewOnly ? '' : `${i18n.global.t('button.save')} `}(${modelRef.refCompanyDocRejectReview?.attribute?.actionText})`,
                classStyle: `m-1 ${modelRef.refCompanyDocRejectReview?.attribute?.btnClass}`,
                confirm: { okButtonProps: { class: modelRef.refCompanyDocRejectReview?.attribute?.btnClass } }
            };
        }
        col1.push(
            createButtonSave({
                onClick: () => {
                    onClickSave({ props, data, refs });
                },
                classStyle: 'm-1',
                options
            })
        );
    }
    if (id && isActive && canSendWait) {
        const statusWait = data.statuses.find(status => status.key === 'Wait');
        col1.push(
            createButton({
                text: `${viewOnly ? '' : `${i18n.global.t('button.save')} & `}${statusWait?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWait?.attribute?.btnClass}`,
                onClick: () => {
                    onClickSave({ props, data, refs, refStatus: statusWait });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
                confirm: { okButtonProps: { class: statusWait.attribute?.btnClass } }
            })
        );
    }
    if (id && isActive && canSendPlan) {
        const statusPlan = data.statuses.find(status => status.key === 'Plan');
        col1.push(
            createButton({
                text: `${viewOnly ? '' : `${i18n.global.t('button.save')} & `}${statusPlan?.attribute?.actionText}`,
                classStyle: `m-1 ${statusPlan?.attribute?.btnClass}`,
                onClick: () => {
                    onClickSave({ props, data, refs, refStatus: statusPlan });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
                confirm: { okButtonProps: { class: statusPlan.attribute?.btnClass } }
            })
        );
    }
    if (id && isActive && canNoPlan) {
        const statusNoPlan = data.statuses.find(status => status.key === 'No plan');
        const text = `${viewOnly ? '' : `${i18n.global.t('button.save')} & `}${statusNoPlan?.attribute?.actionText}`;
        col1.push(
            createButton({
                text,
                classStyle: `m-1 ${statusNoPlan?.attribute?.btnClass}`,
                onClick: () => {
                    openModalFormRemark({
                        title: i18n.global.t('components.table.operatorAndPagination.youAreWant', { text }),
                        onClick: record => {
                            Promise.resolve()
                                .then(() => (modelRef.noPlanRemark = record.remark))
                                .then(() => onClickSave({ props, data, refs, refStatus: statusNoPlan }));
                        }
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>,
                confirm: { okButtonProps: { class: statusNoPlan.attribute?.btnClass } }
            })
        );
    }
    if (id && isActive && canDownloadInvestigationForm) {
        col1.push(
            createButton({
                text: i18n.global.t('views.company.companyDocReject.investigationForm.download'),
                classStyle: 'm-1 btn-primary',
                onClick: () => {
                    onClickReport({
                        callReport: () => callReportInvestigationForm({ data: { id } }),
                        fileName: i18n.global.t('views.company.companyDocReject.investigationForm.download')
                    });
                },
                icon: viewOnly ? null : <CIcon file="pdf.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canDownloadRejectForm) {
        col1.push(
            createButton({
                text: i18n.global.t('views.company.companyDocReject.rejectForm.download'),
                classStyle: 'm-1 btn-primary',
                onClick: () => {
                    onClickReport({
                        callReport: () => callReportFollowupRejectForm({ data: { id } }),
                        fileName: i18n.global.t('views.company.companyDocReject.rejectForm.download')
                    });
                },
                icon: viewOnly ? null : <CIcon file="pdf.svg"></CIcon>
            })
        );
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
                    }),
                classStyle: 'm-1'
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix })
                    }),
                classStyle: 'm-1'
            })
        );
    }
    if (!viewOnly && id && isActive && has({
        menuContext,
        key: 'canDelete'
    }) && ['Draft'].includes(initialModel.refStatus?.key)) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({
                    record: { id },
                    callDelete,
                    setIsLoading: setIsLoadingApp,
                    state,
                    routerPrefix
                }),
                classStyle: 'm-1'
            })
        );
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const openModalList = ({ bind, onIframeMounted }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => (
            <CIFrame
                src={`${process.env.VUE_APP_PUBLIC_PATH}/app/company/company-doc-rejects?isLayout=false&canSelect=true&cacheQuery=true`}
                onIframeMounted={({ refs }) => onIframeMounted({ options, refs })}
            ></CIFrame>
        )
    });
    return options;
};

export const openModalIFrameForm = ({
                                        bind,
                                        companyDocRejectId,
                                        path = 'company-doc-rejects',
                                        mode = 'view',
                                        query
                                    }) => {
    const options = addModal({
        bind: lodash.merge(lodash.cloneDeep(modalStyleIFrame), bind),
        render: () => (
            <CIFrame
                src={`${process.env.VUE_APP_PUBLIC_PATH}/app/company/${path}/${companyDocRejectId}/${mode}?isLayout=false&cacheQuery=true${
                    query ? query : ''
                }`}
            ></CIFrame>
        )
    });
    return options;
};

export const state = reactive({
    columns: [],
    investigationColumns: [],
    followUpColumns: [],
    companyDocRejectColumns: [],
    page: createPage({ options: { select: ['**', 'refCompany.**', 'refCreateBy.fullName'] } }),
    tableOptions: { search: { activeKey: 'Search' } },
    conditionAction: createConditionAction()
});
